// @ts-strict-ignore
import styled from 'styled-components';
import { useSelector } from 'src/store/store';
import i18n from 'src/utils/translate';
import { trackFootfallEvent } from 'src/utils/footfall';
import { Event } from 'src/constants/footfall';
import EmptySearchResults from 'src/modules/search/shared/components/emptySearchResults';
import Pagination from 'src/components/pagination/pagination';
import paginationResultsPerPage from 'src/constants/paginationResultsPerPage';
import CommunityCardLoader from 'src/modules/search/communities/components/communityCardLoader';
import CommunityMemberCard from 'src/modules/community/communityMembers/communityMemberCard';
import PrivatePageErrorMessage from 'src/components/privatePageErrorMessage';

type Props = {
  communitySlug: string;
  isMemberOfCommunity: boolean;
}
export default function SearchMembersResultsList({
  communitySlug = null,
  isMemberOfCommunity = false,
}: Props) {
  const currentUser = useSelector(({ context }) => context.currentUser);
  const {
    communityFilter = 'all',
    isLoading = false,
    membersResults = [],
    searchId = null,
    searchQuery = '',
    totalResults = 0,
  } = useSelector(({ pages }) => pages.search);

  const onMemberCardClick = (username) => {
    trackFootfallEvent(Event.ClickedSearchResult, {
      clickType: 'member-result',
      clickMetadata: { linkType: 'user', searchId, username },
    });
  };

  const count = Number(totalResults).toLocaleString();
  const postLabel = totalResults === 1 ? i18n.t('member') : i18n.t('members');
  const resultsCount = `${count} ${postLabel}`;

  return (
    membersResults.length === 0
      ? currentUser
        ? isLoading
          ? (
            <CommunityCardLoader height={245} isOnTwoColumns={true} />
          ) : (
            <EmptySearchResults
              communitySlug={communitySlug}
              isFiltered={communityFilter !== 'all'}
              isMemberOfCommunity={isMemberOfCommunity}
              query={searchQuery}
              searchType="members"
            />
          )
        : <PrivatePageErrorMessage />
      : (
        <>
          <div>
            <div className="search__summary-row">
              {resultsCount}
            </div>
            <CommunityMembersList>
              {membersResults.map(member => (
                <CommunityMemberCard
                  isOnTwoColumns={true}
                  key={member.username}
                  member={member}
                  onMemberCardClick={onMemberCardClick}
                />
              ))}
            </CommunityMembersList>
          </div>
          <Pagination
            pageSize={paginationResultsPerPage.searchMembers}
            total={totalResults}
          />
        </>
      )
  );
}

const CommunityMembersList = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
  @media (${({ theme }) => theme.underScreenSmall}) {
    padding: 0 15px;
  }
`;
